import { render, staticRenderFns } from "./TabDatosCapital.vue?vue&type=template&id=6a251d4e&scoped=true"
import script from "./TabDatosCapital.vue?vue&type=script&lang=js"
export * from "./TabDatosCapital.vue?vue&type=script&lang=js"
import style0 from "./TabDatosCapital.vue?vue&type=style&index=0&id=6a251d4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a251d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a251d4e')) {
      api.createRecord('6a251d4e', component.options)
    } else {
      api.reload('6a251d4e', component.options)
    }
    module.hot.accept("./TabDatosCapital.vue?vue&type=template&id=6a251d4e&scoped=true", function () {
      api.rerender('6a251d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabDatosCapital.vue"
export default component.exports